exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-51435c60]{background:#1f1f28;display:inline-block;width:100%}.footer .mainCenter[data-v-51435c60]{width:14.066667rem;margin:auto;margin-top:.64rem;font-size:.213333rem;color:#cacaca;line-height:.533333rem}.footer .mainCenter .emailInfo[data-v-51435c60]{clear:both;padding-top:.8rem;color:#9b9d9e}.footer .mainCenter .logo[data-v-51435c60]{width:3.493333rem;height:.64rem;margin-bottom:.72rem;margin-top:.373333rem}", ""]);

// exports
